module.exports = __webpack_public_path__ + "img/temperature.f56a0bdd.svg";